

























































































import Vue from 'vue';
import Component from 'nuxt-class-component';

import { leaderboard } from '../../store/leaderboard';
import { education } from '../../store/education';
import TableHeader from '../../components/leaderboard/education/TableHeader.vue';
import TableRow from '../../components/leaderboard/education/TableRow.vue';
import TablePerPage from '../../components/leaderboard/TablePerPage.vue';

import meta from '../../meta';
import formatNumber from '../../utils/format-number';

// @ts-ignore
@Component({
  components: {
    TableHeader,
    TableRow,
    TablePerPage,
  },
  watchQuery: ['page', 'perpage'],
})
class EducationLeaderboard extends Vue {
  pageToGo: number = this.page;

  head() {
    return meta({
      title: 'Education Leaderboard - CodersRank',
    });
  }

  async fetch({ store, route }: any) {
    const { page, perpage } = route.query;
    if (!store.state.account.username) {
      try {
        await store.dispatch('tryToGetAccount');
        if (store.state.account && store.state.account.username !== '') {
          await store.dispatch('getProfile', { username: store.state.account.username, type: 'user' });
          await store.dispatch(education.actions.AssignEducation, store.state.account.username);
        }
      } catch (err) {
        // error captured in store
      }
    }
    await store.dispatch(leaderboard.actions.GetSchools, { page, perpage });
  }

  get schools() {
    return this.$store.getters[leaderboard.getters.Schools];
  }

  get isLoading() {
    return this.$store.getters[leaderboard.getters.IsLoading];
  }

  get usersPerPage() {
    return this.$store.getters[leaderboard.getters.UsersPerPage];
  }

  get allPages() {
    return this.$store.getters[leaderboard.getters.AllPages];
  }

  get userHasCurrentEducation() {
    return this.$store.getters[leaderboard.getters.HasCurrentRecord];
  }

  get page() {
    return this.$store.getters[leaderboard.getters.CurrentPage];
  }

  formatNumber(number: number) {
    return formatNumber(number);
  }

  // Page number related functions
  usersPerPageUpdated(newVal: number, oldVal: number) {
    const currentTopUser = oldVal * (this.page - 1) + 1;
    const newPage = Math.floor(currentTopUser / newVal) + 1;
    this.pageToGo = newPage;
    this.$router
      .replace({
        name: 'educationLeaderboard',
        query: {
          page: newPage.toString(),
          perpage: newVal.toString(),
        },
      })
      .catch(() => {
        // already on same page
      });
  }

  setPage(page: number | string) {
    if (page > this.allPages || page < 1) {
      return;
    }
    this.pageToGo = page as number;
    this.$router
      .replace({
        name: 'educationLeaderboard',
        query: {
          page: page.toString(),
          perpage: this.usersPerPage,
        },
      })
      .catch(() => {
        // already on same page
      });
  }

  async nextPage() {
    if (this.page === this.allPages || (this.page + 1) * this.usersPerPage > 10000) {
      return;
    }
    this.setPage(this.page + 1);
  }

  async previousPage() {
    if (this.page === 1) {
      return;
    }
    this.setPage(this.page - 1);
  }
}
export default EducationLeaderboard;
